import { render, staticRenderFns } from "./PageBlogDetalhe.vue?vue&type=template&id=6abae2d7&scoped=true&"
import script from "./PageBlogDetalhe.vue?vue&type=script&lang=js&"
export * from "./PageBlogDetalhe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abae2d7",
  null
  
)

export default component.exports